import { Box, Button, Container, Typography } from '@mui/material';
import { FC, useEffect, useState } from 'react';
import { EasTable } from 'ui/EasTable';
import { EasTableWithFilter } from 'ui/EasTableWithFilter';
import { TTableStructure } from 'services/constants/tableStructureTypes';
import {
	downloadSalesReportRequest,
	getUploadedSalesReportsRequest,
} from 'redux/reducers/settings/reducer';
import { useDispatch, useSelector } from 'react-redux';
import {
	getUploadedSalesReportsLoader,
	getUploadedSalesReports,
	getUploadSalesReportLoader,
	getDownloadSalesReportLoader,
} from 'redux/reducers/settings/selectors';
import { PAGE_SIZE } from 'services/constants/env';
import { TUploadedSalesReportsRow } from 'redux/reducers/settings/types';
import { useLocation, useNavigate } from 'react-router-dom';
import { IRequestWithPageSortFilterSearch } from 'services/constants/types';
import queryString from 'query-string';
import { getFiltersFromNavigateParams, getOrderByFromNavigateParams } from 'utils/FilterParams';
import { UploadSalesReportDialog } from './UploadSalesReportDialog';
import { tableStructure } from './tableStructure';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';

export const UploadedSalesReports: FC = () => {
	const dispatch = useDispatch();
	const { search } = useLocation();
	const navigateParams = queryString.parse(search);
	const { page } = queryString.parse(search);

	const requestBody: IRequestWithPageSortFilterSearch = {
		pageNumber: page ? +page : 1,
		pageSize: PAGE_SIZE,
		searchString: String(navigateParams?.search ?? ''),
		filters: getFiltersFromNavigateParams(tableStructure, navigateParams),
		orderBy: getOrderByFromNavigateParams(tableStructure, navigateParams),
	};

	useEffect(() => {
		dispatch(getUploadedSalesReportsRequest(requestBody));
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [dispatch, search]);

	const [openUploadSalesReport, setOpenUploadSalesReport] = useState(false);

	const handleCloseUploadSalesReport = () => {
		setOpenUploadSalesReport(false);
	};

	const uploadedSalesReports = useSelector(getUploadedSalesReports);
	const uploadedSalesReportsLoader = useSelector(getUploadedSalesReportsLoader);
	const uploadSalesReportLoader = useSelector(getUploadSalesReportLoader);
	const downloadSalesReportLoader = useSelector(getDownloadSalesReportLoader);

	// useEffect(() => {
	// 	dispatch(getUploadedSalesReportsRequest({}));
	// }, [dispatch]);

	const handleDownloadSalesReport = (fileId: number, fileName: string) => {
		dispatch(downloadSalesReportRequest({ fileId, fileName }));
	};

	const handleAction = (id: number, typeOfDialog: string) => {
		// console.log('handleDownloadSalesReport', id, typeOfDialog);
		handleDownloadSalesReport(
			id,
			uploadedSalesReports?.data?.find((item) => item.id === id)?.fileName ?? 'unknown',
		);
	};

	return (
		<Box sx={{ margin: '0px 10px 0 10px' }}>
			<EasTableWithFilter<TUploadedSalesReportsRow>
				tableStructure={tableStructure}
				items={uploadedSalesReports}
				itemsIsLoading={
					uploadedSalesReportsLoader || uploadSalesReportLoader || downloadSalesReportLoader
				}
				handleAction={handleAction}
			>
				<Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
					<Typography
						variant="h1"
						color="primary"
						sx={{
							fontSize: '1.2rem',
							fontWeight: 'bold',
							textAlign: 'center',
							ml: 1,
						}}
					>
						Uploaded Sales Reports
					</Typography>
					<Button
						variant="contained"
						color="primary"
						onClick={() => setOpenUploadSalesReport(true)}
						size="small"
						startIcon={<CloudUploadIcon />}
					>
						Upload Sales Report
					</Button>
				</Box>
			</EasTableWithFilter>
			<UploadSalesReportDialog
				open={openUploadSalesReport}
				onClose={handleCloseUploadSalesReport}
				reloadBody={requestBody}
			/>
		</Box>
	);
};
